import { FC, useMemo } from 'react'

import RFFFields from '../../react-final-form-fields'
import { nameofFactory } from '../../../../util'

import { TrainingGroupRequirementsFormFieldsProps, ITrainingGroupRequirementsValues } from './training-group-requirements-form-types'
import { useTrainingTypesQuery } from '../../../../services'

const nameof = nameofFactory<ITrainingGroupRequirementsValues>()

const trainingTypeLabel = 'Training Type(s)'

const TrainingGroupRequirementsFormFields: FC<TrainingGroupRequirementsFormFieldsProps> = props => {
  const { disabled } = props
  const { data: trainingTypes } = useTrainingTypesQuery({ activeOnly: true })

  const typeOptions = useMemo(
    () =>
      trainingTypes?.map(type => ({
        label: type.displayName,
        value: type.id,
        parents: type.trainingCategory?.displayName ? [{ label: type.trainingCategory.displayName, value: type.trainingCategory.id }] : [],
      })) ?? [],
    [trainingTypes],
  )

  return (
    <RFFFields.DualList
      name={nameof('trainingTypeIds')}
      label={trainingTypeLabel}
      unselectedTitle="Available Training Types"
      selectedTitle="Selected Training Types"
      options={typeOptions}
      disabled={disabled}
      canFilter
      filterPlaceholder="Filter by training type"
      displayParentGroups
    />
  )
}

export default TrainingGroupRequirementsFormFields
